module.exports = __webpack_public_path__ + "img/ic_notification_warning.52bcbead.svg";